<template>
<div class="chapter">
<div class="inner_page">
      ﻿
<title>Carolina Gold</title><link href="default.css" rel="stylesheet" type="text/css"/>
<p class="ser"><img alt="00-01_Carolina_Gold.indd 8" class="maxwidth1" id="p0008-d6e10" src="images/9781401687618_IN_0008_002.jpg"/><a id="page8"></a></p><a id="page8">
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chapter3.vue?02f9a81f